import { createFileRoute } from '@tanstack/react-router'

import { DeclineByMidScreen } from './-components/decline-by-mid-screen.tsx'

export const Route = createFileRoute('/risk/decline-by-mid')({
  component: DeclineByMidScreen
})
